import { SalesforceField } from 'model/SalesforceField';
import AlertMessageBase, { IconType } from 'components/Generic/AlertMessageBase';

const SalesforceAlertMessage = ({ fields }: SalesforceField) => {
  return (
    <div className="my-5 salesforce-alert-message">
      <AlertMessageBase
        type={fields.alertType.value.toLowerCase() as IconType}
        title={fields.alertTitle.value}
        defaultExpanded={fields.expandedView.value}
        expandableDescription={fields.alertExpandableText}
        description={fields.alertText}
        showIcon={true}
      />
    </div>
  );
};

export default SalesforceAlertMessage;
